module.exports = __webpack_public_path__ + "static/09 - STA-c8952795718235e312a56ed617df760e.png";